<template>
    <div class="my-5">
        <div
            class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center mb-4"
        >
            <sub-section-header title="Status subskrypcji w sklepach" />
            <search-input
                class="my-3 my-md-0"
                :search-params-tooltip="['nazwie sklepu', 'adresie']"
                :search-input="searchInput"
                @change="searchInput = $event"
            />
        </div>

        <page-preloader v-if="isLoader" min-height="10rem" />

        <div v-else-if="filteredLocations.length" class="subscription-status c-table">
            <div class="c-thead">
                <div v-text="'Nazwa i adres sklepu'" class="c-td is-1" />
                <div v-text="'Wybrany pakiet'" class="c-td is-2" />
                <div v-text="'Status subskrypcji'" class="c-td is-3" />
                <div v-text="'Zintegrowane urządzenia'" class="c-td is-4" />
                <div class="c-td is-5" />
            </div>
            <div class="c-tbody">
                <subscription-status-row
                    v-for="loc in filteredLocations"
                    :key="loc.id"
                    :location="loc"
                />
            </div>
        </div>

        <div v-else v-text="'Brak wyników'" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DEVICE_TYPES, LICENSE_STATE_NAMES } from '@/utils/constants/drs/store-devices.js'

export default {
    data: () => ({
        isLoader: false,
        searchInput: '',
        locations: []
    }),

    async created() {
        await this.mapDevices()
    },

    computed: {
        ...mapGetters('drs', ['shopsWithActiveService']),

        filteredLocations() {
            if (!this.searchInput) return this.locations

            // filter locations by name and address
            const searchQuery = this.searchInput.toLowerCase()
            return this.locations.filter(loc =>
                loc.full_name.toLowerCase().includes(searchQuery) ||
                loc.fullAddress.toLowerCase().includes(searchQuery)
            )
        }
    },

    methods: {
        async fetchDevices() {
            this.isLoader = true
            try {
                const { data, status } = await this.$store.$api.get(
                    'drs/api/proxy/warehouse/diagnostics/[drs_user_id]',
                    {
                        params: {
                            locationIds: this.shopsWithActiveService.map(l => l.id).join(','),
                            mode: 'locations',
                            includes: 'state'
                        },
                        config: { noCancel: true }
                    }
                )

                if (status !== 200 || !data?.locations?.length) {
                    throw new Error('Failed fetchDevices')
                }
                return data.locations
            } catch (error) {
                console.error(error)
            } finally {
                this.isLoader = false
            }
        },

        async mapDevices() {
            const devices = await this.fetchDevices()

            const apiLocationsMap = devices.reduce((acc, loc) => {
                acc[loc.location_id] = loc.devices || []
                return acc
            }, {})

            this.locations = this.shopsWithActiveService.map(location => {
                const devices = apiLocationsMap[location.id] || []

                // Compute device summary (count only ACTIVE devices)
                const deviceSummary = DEVICE_TYPES.reduce((acc, { id, value, label, img }) => {
                    const count = devices.filter(
                        d => d.device_type === value && d?.state?.code === LICENSE_STATE_NAMES.ACTIVE
                    ).length
                    acc[id] = { label, img, count }
                    return acc
                }, {})

                return {
                    ...location,
                    deviceSummary
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.subscription-status {
    .typo-label {
        display: none;
    }
    .c-thead, .c-tr {
        column-gap: 2rem;
    }
    .c-td {
        min-width: var(--width);
        max-width: var(--width)
    }
    .is-2, .is-3, .is-4 {
        text-align: center;
        --width: 12rem;
    }
    .is-3 .status{
        width: 9rem;
    }
    .is-5 {
        --width: 10rem;
    }

    @include media-breakpoint-down(md) {
        .c-tr {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
        }
        .c-td {
            --width: 100%;
            text-align: start;
            &.is-5 {
                grid-column: 2;
            }
        }
        .c-tr .typo-label {
            display: flex;
            margin-bottom: 0.25rem;
        }
        .c-thead {
            display: none;
        }
    }

    @include media-breakpoint-down(xs) {
        .c-tr {
            display: flex;
        }
    }
}
</style>